import { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { Listing } from '@designsystem/stories/04-organisms/Listing';
import { MegaMenuContext } from '@designsystem/stories/04-organisms/MegaMenuContext';
import {
  NormalizableContent,
  transformToCards,
} from '@fhnw/helpers/DesignSystem/cardTransformers';
import { getListingImageSizes } from '@fhnw/helpers/DesignSystem/imageSizes';

export const SCHOOLS_MENU_ID = 'menu-schools';

interface SchoolsMenuProps {
  universities: NormalizableContent[];
}

const SchoolsMenu = ({ universities }: SchoolsMenuProps) => {
  const intl = useIntl();
  const [open] = useContext<any>(MegaMenuContext);
  const [wasOpened, setWasOpened] = useState(false);

  if (!wasOpened && open === SCHOOLS_MENU_ID) {
    setWasOpened(true);
  }

  const items = transformToCards(
    universities,
    intl,
    'teaser-school',
    undefined,
    undefined,
    false,
    getListingImageSizes('teaser-school'),
  ).map((item) => ({
    ...item,
    image: {
      ...item.image,
      aspect: 'portrait' as const,
      children: wasOpened ? (
        item.image?.children
      ) : (
        <div className="media__object" />
      ),
    },
  }));

  return <Listing type="teaser-school" items={items} />;
};

export default SchoolsMenu;
